import React from 'react';
import cn from 'classnames';
import { useInView } from 'react-intersection-observer';
import Container from '../Container';
import { Title } from '@landing/ui';
import Slider from '../Slider';
import Slide from './Slide';
import SlideWide from './SlideWide';
import MoreSpeakersCard from './MoreSpeakersCard';

import * as styles from './Team.module.scss';

export default function Team({ title, slides }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });

  const twoCards = slides?.length <= 2;
  const preparedDesktopCount = twoCards ? 2 : 3;

  const config = {
    desktopSlidesToShow: preparedDesktopCount,
    desktopSlidesToScroll: preparedDesktopCount,
    tabletSlidesToShow: preparedDesktopCount,
    tabletSlidesToScroll: preparedDesktopCount,
  };

  const getSlideComponent = slide => {
    if (slide?.type === 'moreSpeakersCard') {
      return <MoreSpeakersCard {...slide} theme={twoCards ? 'wide' : 'regular'} />;
    }

    const SlideComponent = twoCards ? SlideWide : Slide;
    return <SlideComponent {...slide} />;
  };

  return (
    <Container className={styles.container} background="gray" theme="stairs" id="team">
      <div className={styles.layout}>
        <Title>{title}</Title>
        <div className={cn(styles.sliderWrapper, 'defaultSlider')} ref={inViewRef}>
          {inView && (
            <Slider slides={slides} theme="white" {...config}>
              {slides.map(slide => (
                <div key={slide.title} className={styles.slide}>
                  {getSlideComponent(slide)}
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>
    </Container>
  );
}
